import { atom } from "jotai";
import { INotifMessage } from "../services/assetServices";

export const notifAtom = atom<INotifMessage>({ t: '', b: '', l: 0 });

export interface INotification {
    message: string;
}

export const notificationsAtom = atom<INotification[]>([]);